import { PageType } from 'api/page-template/types';
import { useGetAllEmailPageTemplatesQuery } from 'queries/email-page-templare';
import { useGetAllMeetingPageTemplatesQuery } from 'queries/meeting-page-template';
import { useMemo } from 'react';

export const useTemplatePageSources = () => {
  const {
    data: meetingPageTemplates,
    isLoading: isMeetingPageTemplatesLoading,
  } = useGetAllMeetingPageTemplatesQuery();
  const { data: emailPageTemplates, isLoading: isEmailPageTemplatesLoading } =
    useGetAllEmailPageTemplatesQuery();
  const templatesByPage = useMemo(
    () => ({
      [PageType.Meeting]: meetingPageTemplates ?? [],
      [PageType.Email]: emailPageTemplates ?? [],
    }),
    [meetingPageTemplates, emailPageTemplates],
  );

  return {
    templatesByPage,
    isLoading: isMeetingPageTemplatesLoading || isEmailPageTemplatesLoading,
    meetingPageTemplates,
    emailPageTemplates,
  };
};
